<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M11.3333 17H14.4444C14.857 17 15.2527 16.8361 15.5444 16.5444C15.8361 16.2527 16 15.857 16 15.4444V2.55556C16 2.143 15.8361 1.74733 15.5444 1.45561C15.2527 1.16389 14.857 1 14.4444 1H11.3333M5.88889 12.8889L2 9M2 9L5.88889 5.11111M2 9H12.3333"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'DoorIcon',
  };
</script>
